/**
 * Component untuk menampilkan loading state saat config sedang di-load.
 * Dipakai global di _app.js: semua halaman (contact, shop, index, dll) tampil skeleton yang sama.
 */
import PageSkeleton from "@/components/skeletons/PageSkeleton";
import { useConfig } from "@/context/ConfigContext";
import { useEffect, useState } from "react";

export default function ConfigLoader({ children }) {
  const { loading, error, isConfigReady } = useConfig();
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  // Penting untuk SEO/crawler:
  // saat SSR render children dulu agar <MetaHead /> halaman tetap muncul di HTML awal.
  if (!hasMounted) {
    return children;
  }

  if (loading) {
    return <PageSkeleton />;
  }

  if (error && !isConfigReady) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center p-8 bg-red-50 rounded-lg max-w-md">
          <h2 className="text-xl font-bold text-red-800 mb-2">
            Gagal Memuat Konfigurasi
          </h2>
          <p className="text-red-700 mb-4">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          >
            Muat Ulang
          </button>
        </div>
      </div>
    );
  }

  return children;
}
